import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import WithRoles from '@hobs/hocs/WithRoles';
import ObjectPath from 'object-path';
import { USER_ROLES } from '@hobs/utils/constants';
import _ApprovalSummary from '@hobs/containers/ApprovalSummary';
import withNavigationPrompt from '@hobs/hocs/WithNavigationDialog/WithNavigationPrompt';

import {
  getSorSummary,
  confirmSor,
  confirmFsor,
  validateConfirmFsor,
  crealSorParty
} from '../../actions/sor';
import {
  getApprovalSummary,
  approve,
  cancelApproval,
  clearApprovalSummary
} from '../../actions/approvalSummary';

class ApprovalSummary extends _ApprovalSummary {
  async loadRequiredData() {
    await Promise.all([this.props.getSorSummary(), this.loadApprovalSummary()]);
  }

  async loadApprovalSummary() {
    const { getApprovalSummary } = this.props;
    await getApprovalSummary();
    await this.props.getSorSummary();

    this.props.setNavigationBlocking(
      this.props.sor.sorSummary.canFsorBeConfirmed
    );
  }

  getPartyName() {
    return ObjectPath.get(this.props.sor, 'sorSummary.partyName');
  }

  canUserConfirmIsor() {
    const { hasUserPermission } = this.props;
    return (
      !hasUserPermission(USER_ROLES.READONLY) &&
      !hasUserPermission(USER_ROLES.HOST_UNIT)
    );
  }

  canUserConfirmFsor() {
    const { hasUserPermission } = this.props;
    return (
      !hasUserPermission(USER_ROLES.READONLY) &&
      !hasUserPermission(USER_ROLES.HOST_UNIT)
    );
  }

  canUserApproveUnit() {
    const { hasUserPermission } = this.props;
    return (
      !hasUserPermission(USER_ROLES.READONLY) &&
      !hasUserPermission(USER_ROLES.HOST_UNIT)
    );
  }

  canUserCancelUnitApproval() {
    const { hasUserPermission } = this.props;
    return (
      !hasUserPermission(USER_ROLES.READONLY) &&
      !hasUserPermission(USER_ROLES.HOST_UNIT)
    );
  }

  isConfirmIsorEnabled = () => {
    const { sor } = this.props;
    const { isConfirmIsorDisabled } = this.state;
    return (
      !ObjectPath.get(sor, 'sorSummary.isConfirmIsorEnabled') ||
      isConfirmIsorDisabled
    );
  };

  isConfirmFsorEnabled = () => {
    const { sor } = this.props;
    const { isConfirmFsorDisabled } = this.state;
    return (
      !ObjectPath.get(sor, 'sorSummary.isConfirmFsorEnabled') ||
      isConfirmFsorDisabled
    );
  };

  _cancelApproval(unitId) {
    return this.props.cancelApproval({
      unitId: unitId
    });
  }

  _approveUnit(unitId) {
    return this.props.approve({
      unitId: unitId
    });
  }

  _validateConfirmFsor() {
    return this.props.validateConfirmFsor();
  }

  _confirmIsor() {
    return this.props.confirmSor();
  }

  _confirmFsor() {
    return this.props.confirmFsor();
  }
}

const mapStateToProps = state => ({
  sor: state.sor,
  units: state.approvalSummary.units,
  currentExercise: state.exercise.current
});

const mapDispatchToProps = {
  getSorSummary,
  confirmSor,
  confirmFsor,
  getApprovalSummary,
  approve,
  cancelApproval,
  validateConfirmFsor,
  crealSorParty,
  clearApprovalSummary
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withTranslation()(
    withRouter(
      WithRoles(
        withNavigationPrompt(ApprovalSummary, {
          dialogMessage:
            'All services are approved by units. Do you really want to leave the page without confirming FSOR?'
        })
      )
    )
  )
);
